import React from 'react';
import {DumpTruckSummarySummary} from "../types/dto";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import {DataWithLabel} from "../../../components/data/DataWithLabel";
import {DumpTruckSummaryFields} from "../types/fields";

interface DumpTruckSummaryCardProps {
    summary: DumpTruckSummarySummary
}

function DumpTruckSummaryCard({summary}: DumpTruckSummaryCardProps) {
    return (
        <Card sx={{p: 0}}>
            <CardHeader title={'Resumen'} sx={{py: 0}}/>
            <CardContent sx={{py: 0, '&:last-child': {pb: 1}}}>
                <Grid container spacing={2}>
                    <Grid item md={1.5} xs={12}>
                        <DataWithLabel label={'Activos'} data={summary[DumpTruckSummaryFields.ActiveQuantity]}/>
                    </Grid>
                    <Grid item md={1.5} xs={12}>
                        <DataWithLabel label={'Disponibles'} data={summary[DumpTruckSummaryFields.AvailableQuantity]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Entregados este mes'}
                                       data={summary[DumpTruckSummaryFields.DeliveredCurrentMonth]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Entregados mes pasado'}
                                       data={summary[DumpTruckSummaryFields.DeliveredPreviousMonth]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Cantidad sin facturar'}
                                       dataProps={{sx: {color: 'red'}}}

                                       data={summary[DumpTruckSummaryFields.UnbilledQuantity]}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>

    );
}

export default DumpTruckSummaryCard;